<ng-container *ngIf="options.isLazyLoading === true && paramObj && options.url">
    <div class="overflow-y-auto max-h-80 primary-font bg-gray-50 zuper-sidebar-scroller" *ngIf="totalCustomers > 0"
        apiLazyLoading [dataURL]="options.url" [params]="paramObj" [totalPages]="totalPages"
        (isLoading)="showLazyLoading($event)" (emitter)="lazyLoadingEmit($event)">
        <ng-container *ngTemplateOutlet="customersList"></ng-container>
    </div>
    <div class="flex justify-center w-full h-10 bg-white py-2"
        *ngIf="totalCustomers > 0 && !(options.paramObj.count > totalCustomers || totalCustomers === customers.length)">
        <mat-spinner [diameter]="20" *ngIf="isLazyLoading"></mat-spinner>
    </div>
</ng-container>
<div class="overflow-y-auto max-h-80 primary-font bg-gray-50 zuper-sidebar-scroller"
    *ngIf="customers.length && !options.isLazyLoading">
    <ng-container *ngTemplateOutlet="customersList"></ng-container>
</div>
<div class="relative" *ngIf="customers.length && !options.isLazyLoading && options.url && (totalCustomers > customers?.length)">
    <div class="flex w-full justify-center absolute bottom-2.5">
        <div class="flex py-1 items-center justify-center text-lg font-medium cursor-pointer px-4 rounded-full view-more-customers-button"
            (click)="viewCustomersList($event)">
            {{'sidebar.data.customers.view_all' | translate}}
        </div>
    </div>
</div>
<div class="h-60 flex flex-col items-center justify-center primary-font" *ngIf="!customers.length">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_customer_found.svg" alt="No Customers Associated">
        <h4 class="font-medium mt-4 text-secondary text-base">
            {{(options?.placeholderDisplayKey ?? 'customers.list.not_found.placeholder') | translate}}
        </h4>
    </div>
</div>
<ng-template #customersList>
    <div class="m-3 flex flex-col border rounded-md bg-white" *ngFor="let customer of customers">
        <div class="py-2 px-4 flex items-center">
            <div class="inline-flex overflow-hidden rounded-lg flex-shrink-0">
                <div *ngIf="customer.customer_first_name"
                    class="flex items-center justify-center overflow-hidden uppercase text-3xl font-secondary leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 h-10 w-10 flex-shrink-0 sm:h-9 sm:w-9 lg:h-12 lg:w-12">
                    {{customer.customer_first_name[0]}}
                </div>
            </div>
            <div class="m-2 sm:ml-3 sm:flex-1 break-all max-w-2/4">
                <div class="flex items-center">
                    <h3 [matTooltip]="customer.customer_first_name + (customer.customer_last_name ? ' ' + customer.customer_last_name : '')"
                        *ngIf="customer.is_deleted || !utilityService.hasModuleAccess('CUSTOMER', false, 'from_sidebar')"
                        class="text-base font-bold text-gray-700 truncate cursor-not-allowed">
                        {{customer.customer_first_name}}
                        {{customer.customer_last_name ?? ''}}</h3>
                    <a [matTooltip]="customer.customer_first_name + (customer.customer_last_name ? ' ' + customer.customer_last_name : '')"
                        *ngIf="!customer.is_deleted && utilityService.hasModuleAccess('CUSTOMER', false, 'from_sidebar')"
                        [routerLink]="utilityService.getLink('CUSTOMER', customer.customer_uid)"
                        class="text-base font-bold text-gray-700 truncate hover:underline hover:text-primary-500 cursor-pointer">
                        <h3 class="truncate" (click)="customerViewDetails($event, customer.customer_uid)">
                            {{customer.customer_first_name}}
                            {{customer.customer_last_name ?? ''}}</h3>
                    </a>
                </div>
                <div class="flex items-center leading-6 text-base"
                    *ngIf="!utilityService.isEmptyOrUndefined(customer.no_of_jobs)">
                    <span>{{customer.no_of_jobs}} {{'text.jobs_multiple' | translate}}</span>
                </div>
            </div>
            <div class="ml-auto" *ngIf="customer.is_active === false">
                <badge [options]="getBadgeOptions('INACTIVE', 'Inactive', 'text.inactive')">
                </badge>
            </div>
            <div class="ml-auto" *ngIf="customer.is_active === true && customer.customer_email">
                <div class="flex flex-shrink-0 hover:bg-gray-200 rounded-full items-center justify-center h-12 w-12 cursor-pointer"
                    [matMenuTriggerFor]="customersMailMenu" [matTooltip]="('email' | translate)">
                    <em class="ti ti-mail text-3xl"></em>
                </div>
                <mat-menu #customersMailMenu="matMenu">
                    <div class="p-4 hover:bg-gray-100 flex items-center text-base primary-font">
                        <span class="mr-2">{{customer.customer_email}}</span>
                        <a href="mailto:{{customer.customer_email}}">
                            <em class="ti ti-send ml-auto icon-size-5 cursor-pointer hover:text-primary-500"></em>
                        </a>
                    </div>
                </mat-menu>
            </div>
            <div *ngIf="customer.is_active === true && customer.customer_contact_no && (customer.customer_contact_no.mobile || customer.customer_contact_no.work || customer.customer_contact_no.home)"
                [ngClass]="{'ml-auto': !customer.customer_email}">
                <div class="flex flex-shrink-0 hover:bg-gray-200 rounded-full items-center justify-center h-12 w-12 cursor-pointer"
                    [matMenuTriggerFor]="customersContactMenu"
                    [matTooltip]="('text.contact' | translate)">
                    <em class="ti ti-phone text-3xl"></em>
                </div>
                <mat-menu #customersContactMenu="matMenu">
                    <div class="p-4 hover:bg-gray-100 flex items-center text-base primary-font"
                        *ngIf="customer.customer_contact_no.mobile">
                        <em class="ti ti-device-mobile icon-size-5 mr-2"
                            [matTooltip]="('text.mobile' | translate)"></em>
                        <span class="mr-2">{{customer.customer_contact_no.mobile}}</span>
                        <a href="tel:{{customer.customer_contact_no.mobile}}">
                            <em class="ti ti-phone ml-auto icon-size-5 cursor-pointer hover:text-primary-500"></em>
                        </a>
                    </div>
                    <div class="p-4 hover:bg-gray-100 flex items-center text-base primary-font"
                        *ngIf="customer.customer_contact_no.work">
                        <em class="ti ti-building icon-size-5 mr-2" [matTooltip]="('text.work' | translate)"></em>
                        <span class="mr-2">{{customer.customer_contact_no.work}}</span>
                        <a href="tel:{{customer.customer_contact_no.work}}">
                            <em class="ti ti-phone ml-auto icon-size-5 cursor-pointer hover:text-primary-500"></em>
                        </a>
                    </div>
                    <div class="p-4 hover:bg-gray-100 flex items-center text-base primary-font"
                        *ngIf="customer.customer_contact_no.home">
                        <em class="ti ti-home icon-size-5 mr-2" [matTooltip]="('home' | translate)"></em>
                        <span class="mr-2">{{customer.customer_contact_no.home}}</span>
                        <a href="tel:{{customer.customer_contact_no.home}}">
                            <em class="ti ti-phone ml-auto icon-size-5 cursor-pointer hover:text-primary-500"></em>
                        </a>
                    </div>
                </mat-menu>
            </div>
        </div>
        <div class="pb-2 px-4 w-full" *ngIf="displayCustomerInfo(customer)">
            <div class="flex p-1" *ngIf="customer.customer_organization">
                <div class="flex flex-shrink-0 bg-gray-200 rounded-full items-center justify-center h-7 w-7">
                    <em class="ti ti-building text-2xl"></em>
                </div>
                <div class="flex min-w-0 ml-5 space-y-1">
                    <div class="flex items-center leading-6 truncate">
                        <a *ngIf="!customer.customer_organization?.is_deleted && utilityService.hasModuleAccess('ORGANIZATION', false, 'from_sidebar')"
                            [matTooltip]="customer.customer_organization?.organization_name"
                            [routerLink]="utilityService.getLink('ORGANIZATION', customer.customer_organization?.organization_uid)"
                            class="text-gray-500 text-base truncate font-medium cursor-pointer hover:text-primary-500 hover:underline">
                            <span
                                (click)="organizationViewDetails($event, customer.customer_organization?.organization_uid)">
                                {{customer.customer_organization?.organization_name ?? ''}}
                            </span>
                        </a>
                        <span *ngIf="customer.customer_organization?.is_deleted === true || !utilityService.hasModuleAccess('ORGANIZATION', false, 'from_sidebar')"
                            [matTooltip]="customer.customer_organization?.organization_name"
                            class="text-gray-500 text-base truncate font-medium cursor-not-allowed">
                            {{customer.customer_organization?.organization_name ?? ''}}</span>
                    </div>
                </div>
            </div>
            <div class="flex p-1" *ngIf="customer.customer_category">
                <div class="flex flex-shrink-0 bg-gray-200 rounded-full items-center justify-center h-7 w-7">
                    <em class="ti ti-subtask text-2xl"></em>
                </div>
                <div class="flex min-w-0 ml-5 space-y-1">
                    <div class="flex items-center leading-6 truncate">
                        <span class="text-gray-600 text-base truncate">
                            {{customer.customer_category.category_name ?? ''}}</span>
                    </div>
                </div>
            </div>
            <div class="flex p-1" *ngIf="customer.customer_address">
                <div class="flex flex-shrink-0 bg-gray-200 rounded-full items-center justify-center h-7 w-7">
                    <em class="ti ti-map-pin text-2xl"></em>
                </div>
                <div class="flex min-w-0 ml-5 space-y-1">
                    <div class="flex items-center leading-6">
                        <span class="text-gray-600 text-base next-line-truncate">
                            {{utilityService.getFormattedAddress(customer.customer_address)}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>